import { useMemo } from 'react';

import {
  useIsAskMeAnythingEnabled,
  useIsCalendarInvitationEnabled,
  useIsOnlineMeetingEnabled,
  useIsQuestionsOnlyMode,
} from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventCreationPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventCreationPage'> = (
  options
) => {
  const askMeAnythingEventCreationPageOverrides = options?.overrides?.askMeAnythingEventCreationPage;

  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isCalendarInvitationEnabled = useIsCalendarInvitationEnabled();
  const isOnlineMeetingEnabled = useIsOnlineMeetingEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        calendarInvitationToggleEnabled: isCalendarInvitationEnabled,
        onlineMeetingToggleEnabled: isOnlineMeetingEnabled,
        ...askMeAnythingEventCreationPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMAEnabled,
      calendarInvitationToggleEnabled: isCalendarInvitationEnabled,
      onlineMeetingToggleEnabled: isOnlineMeetingEnabled,
      ...askMeAnythingEventCreationPageOverrides,
    };
  }, [
    askMeAnythingEventCreationPageOverrides,
    isAMAEnabled,
    isCalendarInvitationEnabled,
    isQuestionsOnlyMode,
    isOnlineMeetingEnabled,
  ]);
};
